import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

const RelatedPosts = (props) => {
  return (
    <>
      {props.blog ? (
        <>
          <div className="CommentProductHead">
            <span>مطالب مرتبط</span>
          </div>
          <Swiper className="relatedPosts" slidesPerView={1.7}>
            {props.blog.map((item) => (
              <SwiperSlide className="SwiperRelatedPosts">
                <div className="PostIamge">
                  <img src={item.image} alt="pic" />
                </div>
                <p className="TextComment">{item.title} </p>
                <p className="Time">{item.created_at}</p>
              </SwiperSlide>
            ))}
            .
          </Swiper>
        </>
      ) : null}
    </>
  );
};

export default RelatedPosts;
